import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  // Don't show footer on login/register pages
  if (location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white py-4 mt-auto">
      <Container fluid className="container-xxl">
        <Row>
          <Col md={6}>
            <h5 className="mb-3">{import.meta.env.VITE_APP_NAME || 'Wholesale Store'}</h5>
            <p className="text-light small mb-3">
              Your trusted wholesale partner for premium cannabis products. 
              Competitive pricing, reliable service, fast delivery.
            </p>
            <p className="text-light small mb-0">
              &copy; {currentYear} {import.meta.env.VITE_APP_NAME || 'Stash House'}. All rights reserved. v{import.meta.env.VITE_APP_BUILD_NUMBER || '1.0.0'}
            </p>
          </Col>
          
          <Col md={3}>
            <h6 className="mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-light text-decoration-none small">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/categories" className="text-light text-decoration-none small">Categories</Link>
              </li>
              <li className="mb-2">
                <Link to="/brands" className="text-light text-decoration-none small">Brands</Link>
              </li>
              <li className="mb-2">
                <Link to="/quick-order" className="text-light text-decoration-none small">Quick Order</Link>
              </li>
              <li className="mb-2">
                <Link to="/support" className="text-light text-decoration-none small">Support</Link>
              </li>
            </ul>
          </Col>
          
          <Col md={3}>
            <h6 className="mb-3">Account</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/account" className="text-light text-decoration-none small">Dashboard</Link>
              </li>
              <li className="mb-2">
                <Link to="/orders" className="text-light text-decoration-none small">Order History</Link>
              </li>
              <li className="mb-2">
                <Link to="/account/profile" className="text-light text-decoration-none small">Profile</Link>
              </li>
              <li className="mb-2">
                <Link to="/privacy-policy" className="text-light text-decoration-none small">Privacy Policy</Link>
              </li>
              <li className="mb-2">
                <Link to="/disclaimer" className="text-light text-decoration-none small">Disclaimer</Link>
              </li>
            </ul>
          </Col>
        </Row>
        
        <hr className="my-4 border-secondary" />
        
        <Row className="align-items-center">
          <Col md={6}>
            <small className="text-muted">
              Built with React • Bootstrap • Modern Web Technologies
            </small>
          </Col>
          <Col md={6} className="text-md-end">
            <small className="text-muted">
              Version {import.meta.env.VITE_APP_BUILD_NUMBER || '1.0.0'}
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;